import { useLanguageData } from '@/common/hooks/useLanguageData';
import SavePayment from './components/savePayments/SavePayment';
import {
	DesktopFlex1,
	LetMailButton,
	RulesWrapper,
	SzeryfMobileWrapper,
	Wrapper,
} from './OnePagePayuPaymentV4.styles';
import Timer from './components/timer/Timer';
import Banner from './components/banner/Banner';
import Plan from './components/plan/Plan';
import SzeryfMobile from './images/szeryf-wstega_mobile.png';
import useMakeOnePagePayuPaymentV4 from './hook/useMakeOnePagePayuPaymentV4';
import Email from './components/email/Email';
import Rules from './components/rules/Rules';

const OnePagePayuPaymentV4 = () => {
	const translations = useLanguageData('checkout');
	const {
		email,
		promo,
		selectedOption,
		emailRef,
		correctionEmail,
		handleCreateOrder,
		setCorrectionEmail,
	} = useMakeOnePagePayuPaymentV4();

	return (
		<>
			<Wrapper onSubmit={(e) => handleCreateOrder(e)}>
				<Timer promo={promo} />
				<Banner promo={promo} type={selectedOption?.type?.value} />
				<Plan promo={promo} selectedOption={selectedOption} />
				{!email && (
					<Email
						emailRef={emailRef}
						email={email}
						correctionEmail={correctionEmail}
						setCorrectionEmail={setCorrectionEmail}
					/>
				)}
				{!email && (
					<RulesWrapper>
						<Rules />
					</RulesWrapper>
				)}
				<div style={{ flex: 1 }} />
				{email && <Rules />}
				<LetMailButton type='submit' style={{ fontSize: '18px' }}>
					{translations.pay}
				</LetMailButton>
				<SavePayment />
				<SzeryfMobileWrapper>
					<img src={SzeryfMobile} />
				</SzeryfMobileWrapper>
				<DesktopFlex1 />
			</Wrapper>
		</>
	);
};

export default OnePagePayuPaymentV4;
